var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-product-bar"},[_c('Button',{attrs:{"name":"add-new-product","label":"Add new product","onClick":_vm.openNewProductModal,"data-test-add-prod-btn":""}}),_c('Modal',{attrs:{"isDisplayed":_vm.isNewProductModalDisplayed},on:{"on-close-modal":_vm.handleModalCloseClick}},[_c('InvitationBox')],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-684d1e55","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewProductBar/NewProductBar.vue
// module id = null
// module chunks = 